module.exports = "/_next/static/images/OgProductTour-ea490225d47a8a6a2e82e2f300714cda.jpg";